import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { hideModal } from '../../../actions/_modal'
import Modal from '../../mini/Modal'
import { P2 } from '../../styled/typography/typography'
import useLexicon from '../../../hooks/useLexicon'
import BtnC from '../../styled/buttons/BtnC'
import { AlertWrapper, Header, Divider, BottomButtons } from '../styles'
import AddCheckinSvg from '../../../static/images/icons/icon_checkin_flag_blue.svg'
import RemoveCheckinSvg from '../../../static/images/icons/icon_checkin_flag_removed.svg'

const OverrideCheckinSectionSelect = ({
  checkpoint,
  sectionName,
  onConfirm,
  onCancel
}) => {
  const dispatch = useDispatch()
  const lexicon = useLexicon()

  const close = () => {
    onCancel()
    dispatch(hideModal())
  }

  const getOnClick = applyAll => () => {
    onConfirm(applyAll)
    dispatch(hideModal())
  }

  return (
    <Modal
      width={500}
      top={50}
      borderRadius="30px"
      autoHeight
      allowOverflow
      allowCloseOnExternalClick
      allowEscape
      closeCallback={close}
    >
      <AlertWrapper onClick={e => e.stopPropagation()}>
        <Header lato tight>
          <img height={18} src={checkpoint ? AddCheckinSvg : RemoveCheckinSvg} alt="" />
          <span>{checkpoint ? 'Add ' : 'Remove '}{lexicon.checkin}</span>
        </Header>
        <P2>
          Where do you want to {checkpoint ? 'add' : 'remove'} this {lexicon.checkin.toLowerCase()}?
        </P2>
        <Divider />
        <BottomButtons>
          <BtnC onClick={getOnClick(true)}>All {lexicon.section}s</BtnC>
          <BtnC onClick={getOnClick(false)}>{sectionName}</BtnC>
        </BottomButtons>
      </AlertWrapper>
    </Modal>
  )
}

OverrideCheckinSectionSelect.propTypes = {
  checkpoint: PropTypes.bool.isRequired,
  sectionName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default OverrideCheckinSectionSelect
